import { helpUrl } from '../utils/helpCenter';
import { t } from '../localization/adminText';

export default function IntegrationHelpLink({ article = 'integration-overview' }) {
  return <a className="integration-help-link" href={helpUrl(article)} target="_blank" rel="noopener noreferrer">{t('How to integrate')} <span aria-hidden="true">↗</span></a>;
}
